// extracted by mini-css-extract-plugin
module.exports = {"stickyColHead":"MargenesPrecio_stickyColHead__3wg3F","stickyCol":"MargenesPrecio_stickyCol__3kP4G"};